import { CS_CERTIFICATE_TYPE, CS_PROCTOR_SHADOW_TITLE } from '@/utils/helpers';
import { ThirtyDaysLabel } from './ThirtyDaysLabel';

export const columns = {
  name: {
    key: 'name',
    label: 'Name',
    isSortable: true,
  },
  organLastCall: {
    key: 'organLastCall',
    label: 'Last Call',
    isSortable: false,
  },
  proctorShadowOrgans: {
    key: 'proctorShadowOrgans',
    label: `${CS_PROCTOR_SHADOW_TITLE[CS_CERTIFICATE_TYPE.PROCTOR]} / ${CS_PROCTOR_SHADOW_TITLE[CS_CERTIFICATE_TYPE.SHADOW]}`,
    isSortable: false,
  },
  trialCertificates: {
    key: 'trialCertificates',
    label: 'Trial',
    isSortable: false,
    minWidthClassName: 'min-w-[100px]',
  },
  location: {
    key: 'location',
    label: 'Base Location + Current',
    isSortable: false,
  },
  match: {
    key: 'match',
    label: 'Match',
    isSortable: false,
    minWidthClassName: 'min-w-[117px]',
  },
  thirtyDays: {
    key: 'thirtyDays',
    label: <ThirtyDaysLabel />,
    isSortable: false,
  },
  reservationCondition: {
    key: 'reservationCondition',
    label: 'Reservation condition',
    isSortable: false,
  },
  reserve: {
    key: 'reserve',
    label: '',
    isSortable: false,
  },
};

export const getCSColumns = (isSwap?: boolean) => {
  const cols = [
    columns.name,
    columns.organLastCall,
    columns.proctorShadowOrgans,
    columns.trialCertificates,
    columns.location,
    columns.match,
    columns.thirtyDays,
    columns.reservationCondition,
  ];

  if (isSwap) {
    cols.unshift(columns.reserve);
  } else {
    cols.push(columns.reserve);
  }

  return cols;
};
